import { SubprogramModel } from '@modules/subprogram/subprogram-model';

const fields = new SubprogramModel().fields();

export default [
    fields.id,
    fields.gender,
    fields.locations,
    fields.type,
    fields.createdAt
];